export const INTEGRATION_CREDENTIALS_NOT_CONFIGURED = "INTEGRATION_CREDENTIALS_NOT_CONFIGURED";
export const INTEGRATION_SETTINGS_INVALID = "INTEGRATION_SETTINGS_INVALID";
